import { createCustomEvent } from "../events/custom_event.js";
import { PostGridEvent } from "../events/post_grid_event.js";
import { DickTokComponent } from "./Component.js";
import { defineElement } from "./registry.js";

export class DickTokPostThumbnail extends DickTokComponent {
  /**
   * Event handler for user interaction with the component that opens the post
   * in the current window.
   *
   * Since the post grid can appear in multiple contexts and the event handling
   * is different (opens a different URL on profile vs. search), the thumbnail
   * itself handles the data-action, but we dispatch an event that both the
   * profile and search page can listen for to respond appropriately.
   */
  openPosts() {
    this.dispatchEvent(createCustomEvent(PostGridEvent.OPEN_POST));
  }
}

defineElement("dicktok-postthumbnail", DickTokPostThumbnail);
